export async function generateApiKeySec(
  secret: string,
  timestamp = Math.floor(Date.now() / 1000)
): Promise<string> {
  const encoder = new TextEncoder();
  const secretKey = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const message = encoder.encode(`${timestamp}`);
  const signature = await crypto.subtle.sign('HMAC', secretKey, message);
  const hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(
    /=/g,
    ''
  );

  return `${timestamp}.${hash}`;
}
